export default __webpack_public_path__ + "static/media/whatsapp.a12921cb.svg";